const messagesLoader: {
  [key: string]: (fileName: string) => Promise<any>;
} = {
  en: (fileName: string) => import(`./en/${fileName}.json.js`),
};

export default messagesLoader;
